import { styled } from '@mui/material/styles';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import * as React from 'react';
import { CSSProperties } from 'react';

const CustomSvgIcon = styled(SvgIcon, {
  name: 'BoarIcon',
  shouldForwardProp: (_) => true,
})<SvgIconProps>(() => ({}));

const style: CSSProperties = {
  stroke: 'none',
  strokeWidth: 1,
  strokeDasharray: 'none',
  strokeLinecap: 'butt',
  strokeDashoffset: 0,
  strokeLinejoin: 'miter',
  strokeMiterlimit: 4,
  fillRule: 'nonzero',
  opacity: 1,
};

export const BoarIcon: React.FC<SvgIconProps> = ({ width = 512, height = 512, viewBox = '0 0 512 512', ...props }) => (
  <CustomSvgIcon data-testid="BoarIcon" width={width} height={height} viewBox={viewBox} {...props}>
    <g transform="matrix(1 0 0 1 256 256)">
      <rect
        style={{
          ...style,
          visibility: 'hidden',
        }}
        vectorEffect="non-scaling-stroke"
        x="-256"
        y="-256"
        rx="0"
        ry="0"
        width="512"
        height="512"
      />
    </g>
    <g transform="matrix(0 0 0 0 0 0)"></g>
    <g transform="matrix(6.76 0 0 6.76 256.17 256.96)">
      <g vectorEffect="non-scaling-stroke">
        <g transform="matrix(1 0 0 1 -6.59 15.44)">
          <path
            style={style}
            vectorEffect="non-scaling-stroke"
            transform=" translate(-25.41, -59.44)"
            d="M 24 55 L 25 61 C 23.85810231180532 61.58539957781525 23.10117742252382 62.720786911737505 23 64 L 26 64 C 26.027036417125952 62.502417744533105 26.690438087497267 61.08718606172236 27.824219999999997 60.1084 L 26.95337 54.884890000000006 C 25.92554 54.95782 24.9328 55 24 55 Z"
            strokeLinecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -23 7)">
          <path
            style={style}
            vectorEffect="non-scaling-stroke"
            transform=" translate(-9, -51)"
            d="M 5 55 C 5 55 13 54 13 47 L 9 47 C 8.885580328760918 50.11945490411655 7.426912120549796 53.0367913205388 5.000000000000001 55 Z"
            strokeLinecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 0 0)">
          <path
            style={style}
            vectorEffect="non-scaling-stroke"
            transform=" translate(-32, -44)"
            d="M 62.18457 50.39 L 63 42.99028 C 62.9519100188589 42.70620420055171 62.82771236754424 42.440477626807066 62.64062 42.22137 L 58.96942 39.16063 C 58.98883 38.47177 59 37.75025 59 36.9875 C 59 23.981499999999997 37 26.982879999999998 37 26.982879999999998 L 37 25 L 31 27 L 31 24 L 23 27.99121 L 24 24.99121 C 17 26.99121 10 36.991209999999995 8 38.991209999999995 C 6 40.991209999999995 1 41.991209999999995 1 41.991209999999995 L 3 47.991209999999995 C 3 47.991209999999995 4.38641 48.568419999999996 6.5668299999999995 49.330079999999995 C 6.813232723545073 48.56882404129981 6.958861411797143 47.77857231953138 7 46.97949 L 7.00006 46.97437 C 7.01307363001136 45.88131334824559 7.902017056585924 45.00160204042187 8.99515 45 L 13 44.99415 C 13.532828450989658 44.9960679624342 14.04303082586356 45.20976074380178 14.418182330878667 45.58814042751754 C 14.793333835893774 45.9665201112333 15.002647370596597 46.47853467384436 15 47.011359999999996 C 15.018531534051252 48.58899242964355 14.633824451071423 50.145217170075185 13.88235 51.5325 C 17.185874131289097 52.41508667076335 20.581767473285602 52.90593072864923 24.000000000000014 52.99491 C 25.54421489284128 52.98320894783448 27.086867846942614 52.89396321049548 28.622129999999977 52.727509999999995 L 30 60.99861 C 28.857906943823576 61.58449280475979 28.101001236649626 62.7203774149872 28 64 L 34 64 L 34 51.9931 C 41.1936 50.8078 48 48.9931 48 48.9931 L 52 56.9968 L 51 59.99819 C 51 59.99819 48 59.99819 48 64.00004 L 55 64.00004 L 57 55.99634 L 56 51.99449 C 56 51.99449 58.24384 50.490919999999996 58.84955 41.666489999999996 L 60.94629 43.41437 L 60.196839999999995 50.16419 C 59.47005457619879 50.48273388809169 59.0004185905769 51.200921748661465 59 51.99445 C 59 53.09951 61 55.9963 61 55.9963 C 61 55.9963 63 53.099509999999995 63 51.99445 C 62.998946442623115 51.36035639158371 62.696173511870946 50.7646166852382 62.18457 50.39 Z M 17 39 L 15 39 L 15 37 L 17 37 Z M 23 36 C 23 36 23 32 28 31 C 28 31 30 37 23 36 Z M 40 32 L 38 32 C 37.4477152501692 32 37 31.552284749830793 37 31 C 37 30.447715250169207 37.4477152501692 30 38 30 L 40 30 C 40.5522847498308 30 41 30.447715250169207 41 31 C 41 31.552284749830793 40.5522847498308 32 40 32 Z M 46 36 L 44 36 C 43.4477152501692 36 43 35.5522847498308 43 35 C 43 34.4477152501692 43.4477152501692 34 44 34 L 46 34 C 46.5522847498308 34 47 34.4477152501692 47 35 C 47 35.55228474983079 46.5522847498308 36 46 36 Z M 47 31 C 46.999848670750474 30.734737147186728 47.10515691449935 30.480295299587247 47.2927261070433 30.292726107043297 C 47.48029529958725 30.10515691449935 47.73473714718673 29.999848670750474 48 30 L 50 30 C 50.5522847498308 30 51 30.447715250169207 51 31 C 51 31.552284749830793 50.5522847498308 32 50 32 L 48 32 C 47.73473714718673 32.000151329249526 47.48029529958725 31.89484308550065 47.2927261070433 31.707273892956703 C 47.10515691449935 31.519704700412753 46.999848670750474 31.265262852813272 47 31 Z"
            strokeLinecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 13.92 13.67)">
          <path
            style={style}
            vectorEffect="non-scaling-stroke"
            transform=" translate(-45.92, -57.67)"
            d="M 49.84082 57.15332 L 46.933170000000004 51.33807 C 46.081790000000005 51.55042 44.930420000000005 51.82965 43.570170000000005 52.14032 L 46 57 L 45 60 C 45 60 42 60 42 64 L 46 64 C 46 60.6377 47.74414 58.91113 49.46387 58.2832 Z"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </CustomSvgIcon>
);
